import { SystemIcon } from '@storeblocks/icon';
import { type FC } from 'react';
import styled from 'styled-components';

interface Props {
  title: string;
  url: string;
  'data-test': string;
  'data-trackid': string;
}

export const DownloadLink: FC<Props> = ({
  title,
  url,
  'data-test': dataTest,
  'data-trackid': dataTrackid,
}) => {
  return (
    <Link
      href={url}
      target="_blank"
      data-test={dataTest}
      data-trackid={dataTrackid}
      className="font-body"
    >
      <Container>
        <SystemIcon name="pdf" isPhosphor />
        <SpanWithLinkStyle>{title}</SpanWithLinkStyle>
      </Container>

      <SystemIcon name="download" isPhosphor />
    </Link>
  );
};

const Link = styled.a`
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--p-color-stroke-subtle-0);
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SpanWithLinkStyle = styled.span`
  text-decoration: underline;
`;
